// Win-back, 3 days after a lapse. MARKETING — pass `unsubscribeUrl` (PECR).

import type { EmailData } from "../../types";
import { b, body, call, esc, p } from "../../layouts/chrome";
import { callCta, plainEmailHtml } from "../../layouts/plain";
import { brand } from "../brand";

export const subject = (_data: EmailData) => "We'd love to have you back — £25 Amazon voucher inside";

export const html = (data: EmailData) =>
  plainEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    heading: "We'd love to have you back",
    cta: callCta(brand.callNumber),
    unsubscribeUrl: data.unsubscribeUrl,
    bodyHtml: body(
      p(
        `We're sorry to see your policy for ${b(`'${esc(data.companyName)}'`)} come to an end — and we'd love a second chance.`,
      ),
      p(
        `Come back to ${brand.name} and we'll send you a ${b("£25 Amazon voucher")} as a thank you when your new policy starts. Getting covered again takes just a few minutes over the phone.`,
      ),
      p(
        `Call our UK-based team on ${call(brand)} and we'll get your business back on cover today.`,
      ),
      p(
        "£25 Amazon voucher: one per business, issued after your new policy has been active for 30 days. Ask our team for full terms.",
      ),
    ),
  });
